import { render, staticRenderFns } from "./Diploma.vue?vue&type=template&id=23ebbdd3&scoped=true&"
import script from "./Diploma.vue?vue&type=script&lang=js&"
export * from "./Diploma.vue?vue&type=script&lang=js&"
import style0 from "./Diploma.vue?vue&type=style&index=0&id=23ebbdd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ebbdd3",
  null
  
)

export default component.exports